import { gql } from "@apollo/client";
import { AsyncActionStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import { useResettableMutation } from "../useResettableMutation";
import { DismissNotifications, DismissNotificationsVariables } from "./__generated__/DismissNotifications";

const DISMISS_NOTIFICATIONS = gql`
  mutation DismissNotifications($notificationIds: [String!]) {
    dismissNotifications(input: { notificationIds: $notificationIds }) {
      successful
    }
  }
`;

export function useDismissNotifications() {
  const [mutate, { loading, data, error, reset, called }] = useResettableMutation<
    DismissNotifications,
    DismissNotificationsVariables
  >(DISMISS_NOTIFICATIONS, {
    errorPolicy: "all",
  });
  return {
    mutate,
    data,
    status: {
      loading,
      reset,
      called,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncActionStatus,
  };
}
